/**
 * Add responsive wrapper to content tables
 */
jQuery('.article__post-content table').wrap('<div class="table-responsive"/>')